// お問い合わせのプライバシーの開閉

document.addEventListener('DOMContentLoaded', function () {
    const togglerButtons = document.querySelectorAll('.js-toggleunit__button');
    const privacyBody = document.querySelector('.p-privacy__body');

    togglerButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault(); // ページ遷移を防ぐ

            const action = button.getAttribute('data-toggler-btn');

            if (action === 'toggle') {
                privacyBody.classList.add('is-open');
            } else if (action === 'close') {
                privacyBody.classList.remove('is-open');
            }
        });
    });
});


// ハンバーガーメニューの開閉

(function ($) {

    // ハンバーガー
    $('.js-hamburger').on('click', function (el) {
        $('.p-menu').toggleClass('is-opened');
        $('html,body').toggleClass('is-hamburger-opened');
        return false;
    });

    $('.p-menu__overlay').on('click', function (el) {
        $('.p-menu').removeClass('is-opened');
        $('html,body').removeClass('is-hamburger-opened');
        return false;
    })

})(jQuery);

// 画面読み込み時ヘッダーが上から降りてくる
document.addEventListener("DOMContentLoaded", function () {
    // ヘッダー要素にis-visibleクラスを追加
    document.querySelector(".l-header").classList.add("is-visible");
});

// 画面内に要素が入ったら下から上がってくる
document.addEventListener("DOMContentLoaded", function () {
    // js-inview クラスを持つすべての要素を取得
    const inviewElements = document.querySelectorAll(".js-inview");

    // Intersection Observer の設定
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 要素が画面内に入ったら js-inview-on クラスを追加
                entry.target.classList.add("js-inview-on");
                observer.unobserve(entry.target); // 1回だけ処理する場合は監視を停止
            }
        });
    });

    // 取得した要素を監視
    inviewElements.forEach(element => {
        observer.observe(element);
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//     const items = document.querySelectorAll(".p-mainvisual__item");
//     let currentIndex = 0;
//     const duration = 10000; // 5秒

//     // 最初の要素にactiveクラスを付ける
//     items[currentIndex].classList.add("active");

//     function changeSlide() {
//         // 現在のスライドを非表示
//         items[currentIndex].classList.remove("active");

//         // インデックスを次に進める (ループする)
//         currentIndex = (currentIndex + 1) % items.length;

//         // 次のスライドを表示
//         items[currentIndex].classList.add("active");
//     }

//     // 5秒ごとにスライドを切り替える
//     setInterval(changeSlide, duration);
// });


// document.addEventListener("DOMContentLoaded", function () {
//     const items = document.querySelectorAll(".p-mainvisual__item");
//     const dots = document.querySelectorAll(".p-mainvisual__dot");
//     let currentIndex = 0;
//     const duration = 10000;

//     // 最初の要素にactiveクラスを付ける
//     function updateSlide(index) {
//         items.forEach((item, i) => {
//             item.classList.remove("active");
//             dots[i].classList.remove("active");
//         });
//         items[index].classList.add("active");
//         dots[index].classList.add("active");
//         currentIndex = index;
//     }

//     updateSlide(currentIndex);

//     // 自動スライド
//     function changeSlide() {
//         let nextIndex = (currentIndex + 1) % items.length;
//         updateSlide(nextIndex);
//     }

//     setInterval(changeSlide, duration);

//     // ナビゲーションボタンをクリックしたときの処理
//     dots.forEach((dot, index) => {
//         dot.addEventListener("click", () => {
//             updateSlide(index);
//         });
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".p-mainvisual__item");
    const dots = document.querySelectorAll(".p-mainvisual__dot");
    let currentIndex = 0;
    const duration = 10000; // 10秒
    let slideTimer; // タイマーのインスタンス

    // スライドを更新する関数
    function updateSlide(index) {
        items.forEach((item, i) => {
            item.classList.remove("active");
            dots[i].classList.remove("active");
        });
        items[index].classList.add("active");
        dots[index].classList.add("active");
        currentIndex = index;
    }

    // スライドのタイマーをリセットする関数
    function resetTimer() {
        clearInterval(slideTimer); // 現在のタイマーをクリア
        slideTimer = setInterval(changeSlide, duration); // 新しいタイマーを設定
    }

    // 自動スライドの関数
    function changeSlide() {
        let nextIndex = (currentIndex + 1) % items.length;
        updateSlide(nextIndex);
    }

    // 初期スライド設定とタイマー開始
    updateSlide(currentIndex);
    slideTimer = setInterval(changeSlide, duration);

    // ナビゲーションボタンをクリックしたときの処理
    dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
            updateSlide(index); // クリックしたスライドに移動
            resetTimer(); // タイマーをリセットしてカウントダウンをやり直す
        });
    });
});

